import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 获取job下客户门点多柜对应装箱明细 jobUuid
export function queryTruckingByJob(params) {
  return request({
    url: URL.seaExport.queryTruckingByJob,
    method: 'get',
    params
  })
}

// 获取客户门点多柜对应已选择的装箱 truckingInfoUuid
export function queryTruckingByTruck(params) {
  return request({
    url: URL.seaExport.queryTruckingByTruck,
    method: 'get',
    params
  })
}

// 获取客户门点多柜对应未选择的装箱 jobUuid
export function queryByCheckTrucking(params) {
  return request({
    url: URL.seaExport.queryByCheckTrucking,
    method: 'get',
    params
  })
}

// 客户门点-多柜-添加装箱明细
export function addTruckingRecord(data) {
  return request({
    url: URL.seaExport.addTruckingRecord,
    method: 'post',
    data
  })
}

// 客户门点-多柜-移除装箱明细
export function delTruckingRecord(data) {
  return request({
    url: URL.seaExport.delTruckingRecord,
    method: 'post',
    data
  })
}

// 导入excel
export function importTruckExcelData(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.seaExport.importTruckExcelData,
    config: {
      headers: {
        'Content-Type': 'multipart/form-data; charset=UTF-8'
      }
    },
    method: 'post',
    data
  })
}
